import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledItem = styled.div<{ fixedColumnWidth?: boolean }>`
    padding: 10px 15px;
    background: linear-gradient(
        to bottom,
        ${({ theme }: any) => theme.colors.deepBlue} 0%,
        ${({ theme }: any) => theme.colors.turtle} 100%
    );
    white-space: nowrap;
    width: ${({ fixedColumnWidth }) => fixedColumnWidth && 'max-content'};
    min-width: ${({ fixedColumnWidth }) => fixedColumnWidth && '180px'};

    & button {
        width: 190px;
    }

    ${media.md`
    padding: 12px 15px;
    
    & button {
      height: 50px;
    }
  `}

    &:last-child {
        grid-column: 1 / -1;
    }
`;

export const StyledItemValue = styled(Typography)`
    color: ${({ color }) => color || 'white'};

    ${media.md`
    font-size: 20px;
  `}
`;

export const StyledItemLabel = styled(Typography)`
    color: ${({ theme }: any) => theme.colors.white};
    margin-top: 5px;
    white-space: nowrap;

    ${media.md`
    font-size: 14px;
  `}
`;
